import { createContext } from "react";

export const ProgressContext = createContext({
  percentage: 0,
  resetProgress: () => {},
  nextBtn: () => {},
  nextBtnInvalidInput: () => {},
});